// eslint-disable-next-line
import React from "react";

import image8 from "../../assest/arrival_products/phone/phone_8.avif";
import image9 from "../../assest/arrival_products/phone/phone_9.avif";
import image10 from "../../assest/arrival_products/phone/phone_10.avif";

import image11 from "../../assest/arrival_products/watch/watch_1.avif";
import image12 from "../../assest/arrival_products/watch/watch_2.avif";
import image13 from "../../assest/arrival_products/watch/watch_3.avif";
import image14 from "../../assest/arrival_products/watch/watch_4.avif";
import image15 from "../../assest/arrival_products/watch/watch_5.avif";
import image16 from "../../assest/arrival_products/watch/watch_6.avif";
import image17 from "../../assest/arrival_products/airpods/airpods_1.avif";
import image18 from "../../assest/arrival_products/airpods/airpods_2.avif";
import image19 from "../../assest/arrival_products/airpods/airpods_3.avif";
import image20 from "../../assest/arrival_products/airpods/airpods_4.avif";
import image21 from "../../assest/arrival_products/airpods/airpods_5.avif";
import image22 from "../../assest/arrival_products/airpods/airpods_6.avif";
import image23 from "../../assest/arrival_products/airpods/airpods_7.avif";
import image24 from "../../assest/arrival_products/earphone/earphone_1.avif";
import image25 from "../../assest/arrival_products/earphone/earphone_2.avif";
import image26 from "../../assest/arrival_products/earphone/earphone_3.avif";
import image27 from "../../assest/arrival_products/earphone/earphone_4.avif";
import image28 from "../../assest/arrival_products/earphone/earphone_5.avif";

import image29 from "../../assest/arrival_products/tv/tv_1.avif";
import image30 from "../../assest/arrival_products/tv/tv_2.avif";
import image31 from "../../assest/arrival_products/tv/tv_3.avif";
import image32 from "../../assest/arrival_products/tv/tv_4.avif";
import image33 from "../../assest/arrival_products/tv/tv_5.avif";

import { useMemo } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import {
  EffectCoverflow,
  Pagination,
  Navigation,
  Autoplay,
} from "swiper/modules";
import { Link } from "react-router-dom";


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const desktopImages = [
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25,
  image26,
  image27,
  image28,
  image8,
  image9,
  image10,
  image29,
  image30,
  image31,
  image32,
  image33,
];

// Swiper.use([EffectCoverFlow, Autoplay, Pagination, Navigation]);

const DiscountCardSwiper = () => {
  const shuffledImages = useMemo(() => shuffleArray([...desktopImages]), []);

  return (
    <div className="container m-auto py-4 mb-10">
      <h1
        style={{ fontFamily: "serif" }}
        className="text-3xl font-bold text-center py-4 mb-4"
      >
        {/* Discount Products */}
        White Friday Sale
      </h1>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        spaceBetween={20}
        slidesPerView={"auto"}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        breakpoints={{
          320: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        pagination={{
          el: ".swiper-pagination",
          clickable: true,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          clickable: true,
        }}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        className="swiper_container"
      >
        {shuffledImages.map((image, index) => (
          <SwiperSlide key={index}>
            <Link to={"/discount-products"}>
              <img
                className="w-[420px] h-[220px] object-contain "
                src={image}
                alt={`Slide ${index + 1}`}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DiscountCardSwiper;
